import utils from 'lib/utils';

const LocalStorageService = {
  getItem: function ls_getItem(key) {
    return utils.tryParseJson(localStorage.getItem(key));
  },

  getByDotString: function(dotString) {
    return utils.getByDotString(dotString, this.getItem);
  },

  setItem: function ls_setItem(key, value) {
    try {
      if(typeof value === 'object' || Array.isArray(value)) {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, value);
      }
    } catch(e) {
      // eslint-disable-next-line no-console
      console.warn('Caught and ignored exception: failed to set item in localStorage:', e);
    }
  },

  removeItem: function ls_removeItem(key) {
    return localStorage.removeItem(key);
  },

  clear: function ls_clear() {
    localStorage.clear();
  }

};

module.exports = LocalStorageService;
